import React from "react";

const TaxesPage = () => {
  return <div>Taxes Page</div>;
};

export default TaxesPage;
